import { useState } from "react";
import { NavLink, Link } from "react-router-dom";
import GrantaEarthLogo from "./ui/GrantaEarthLogo";

const nav = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/units/mining", label: "Mining" },
  { to: "/units/energy", label: "Energy" },
  { to: "/units/commodities", label: "Commodities" },
  { to: "/partnerships", label: "Partnerships" },
  { to: "/contact", label: "Contact" },
];

export default function Header() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 bg-white/95 backdrop-blur-sm border-b border-gray-200/50 shadow-sm">
      <div className="container-custom">
        <div className="flex items-center justify-between h-16">
          <Link 
            to="/" 
            className="focus:outline-none focus:ring-2 focus:ring-deep-green focus:ring-offset-2 rounded-lg p-1 -m-1"
          >
            <GrantaEarthLogo size="lg" className="hover:scale-105 transition-transform duration-200" />
          </Link>

          {/* Desktop nav */}
          <nav className="hidden md:flex items-center gap-8">
            {nav.map(item => (
              <NavLink
                key={item.to}
                to={item.to}
                className={({ isActive }) =>
                  [
                    "relative text-sm font-medium transition-all duration-200",
                    "hover:text-deep-green focus:outline-none focus:ring-2 focus:ring-deep-green focus:ring-offset-2 rounded px-2 py-1",
                    isActive 
                      ? "text-deep-green after:absolute after:bottom-0 after:left-0 after:right-0 after:h-0.5 after:bg-deep-green after:rounded-full after:animate-in after:slide-in-from-bottom-1" 
                      : "text-charcoal hover:text-deep-green"
                  ].join(" ")
                }
              >
                {item.label}
              </NavLink>
            ))}
            <Link 
              to="/contact" 
              className="btn-primary ml-4 focus:ring-deep-green focus:ring-offset-2"
            >
              Trade Desk
            </Link>
          </nav>

          {/* Mobile toggle */}
          <button
            onClick={() => setOpen(v => !v)}
            className="md:hidden inline-flex items-center justify-center h-10 w-10 rounded-lg border border-gray-300 text-charcoal hover:text-deep-green hover:border-deep-green focus:outline-none focus:ring-2 focus:ring-deep-green focus:ring-offset-2 transition-all duration-200"
            aria-label="Toggle navigation menu"
            aria-expanded={open}
          >
            <svg className="h-5 w-5" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
              {open ? (
                <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
              ) : (
                <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16M4 18h16" />
              )}
            </svg>
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      {open && (
        <div className="md:hidden border-t border-gray-200 bg-white shadow-lg">
          <nav className="container-custom py-4">
            <div className="flex justify-center mb-4">
              <GrantaEarthLogo size="md" />
            </div>
            <ul className="flex flex-col space-y-1">
              {nav.map(item => (
                <li key={item.to}>
                  <NavLink
                    to={item.to}
                    onClick={() => setOpen(false)}
                    className={({ isActive }) =>
                      [
                        "block py-3 px-4 text-sm font-medium rounded-lg transition-all duration-200",
                        "hover:bg-deep-green/5 hover:text-deep-green focus:outline-none focus:ring-2 focus:ring-deep-green focus:ring-offset-2",
                        isActive ? "text-deep-green bg-deep-green/5" : "text-charcoal"
                      ].join(" ")
                    }
                  >
                    {item.label}
                  </NavLink>
                </li>
              ))}
              <li className="pt-4 border-t border-gray-200 mt-4">
                <Link 
                  to="/contact" 
                  onClick={() => setOpen(false)} 
                  className="btn-primary w-full inline-flex justify-center focus:ring-deep-green focus:ring-offset-2"
                >
                  Trade Desk
                </Link>
              </li>
            </ul>
          </nav>
        </div>
      )}
    </header>
  );
}